module.exports = __webpack_public_path__ + "static/media/pods_white.06329393.svg";